module.exports = __webpack_public_path__ + "img/as.f94400a2.svg";